// frontend/src/components/NewsletterSubscriberAuth.js
/**
 * Newsletter Subscriber Auto-Login Handler
 * Handles authentication when users click links from newsletter emails
 */

import { useEffect, useState } from 'react';
import { useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import axios from 'axios';

const NewsletterSubscriberAuth = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking'); // 'checking', 'success', 'error', 'guest'

  useEffect(() => {
    const subscriberId = searchParams.get('subscriber');

    if (subscriberId) {
      handleSubscriberAuth(subscriberId);
    }
  }, [searchParams]);

  const handleSubscriberAuth = async (subscriberId) => {
    try {
      setStatus('checking');

      // Verify subscriber and get auth info
      const apiBase = process.env.REACT_APP_API_URL || 'https://api.focusview.ai';
      const response = await axios.get(
        `${apiBase}/newsletter/verify-subscriber/${subscriberId}`
      );

      if (response.data.has_account && response.data.access_token) {
        // User has account - auto-login
        authService.setToken(response.data.access_token);
        localStorage.setItem('current_user', JSON.stringify(response.data.user));

        setStatus('success');

        // Remove subscriber param and continue to page
        const newUrl = window.location.pathname + window.location.search.replace(/[?&]subscriber=[^&]+/, '').replace(/^&/, '?');
        window.history.replaceState({}, '', newUrl || window.location.pathname);

        // Force refresh to update nav
        window.location.reload();
      } else {
        // Subscriber but no account - continue as guest
        setStatus('guest');

        // Remove subscriber param
        const newUrl = window.location.pathname + window.location.search.replace(/[?&]subscriber=[^&]+/, '').replace(/^&/, '?');
        window.history.replaceState({}, '', newUrl || window.location.pathname);
      }

    } catch (error) {
      console.error('Subscriber auth error:', error);
      setStatus('error');

      // Remove invalid subscriber param
      const newUrl = window.location.pathname + window.location.search.replace(/[?&]subscriber=[^&]+/, '').replace(/^&/, '?');
      window.history.replaceState({}, '', newUrl || window.location.pathname);
    }
  };

  // Don't show anything - this component works silently in background
  return null;
};

export default NewsletterSubscriberAuth;